(function($, window, undefined) {
    function isValidEmail(email) {
        var isValid = false;

        var validEmailRegExp = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (email.length && validEmailRegExp.test(email)) {
            isValid = true;
        }

        return isValid;
    }

    function isValidOrderId(orderId) {
        var isValid = false;

        if (orderId.length) {
            isValid = true;
        }

        return isValid;
    }

    function getPromise(url, success, error, data) {
        return new Promise(function(resolve, reject) {
            if (url) {
                $.ajax({
                    url: url,
                    type: 'GET',
                    cache: false,
                  	data: data,
                    crossDomain: true,
                    success: function(response) {
                        if (success && typeof success === 'function') {
                            success(response);
                        }

                        resolve(response);
                    },
                    error: function(response) {
                        if (error && typeof error === 'function') {
                            error(response);
                        }

                        reject(response);
                    }
                })
            } else {
                reject('url not found');
            }
        });
    }

    function getOrder(email, orderId) {
        if (window.order.data && window.order.data.id == orderId && window.order.data.email === email) {
            window.stepController.enableNextStep();
            window.stepController.goToStep(window.stepController.getActiveStep() + 1);
        } else {
            var domain = window.location.hostname.split('.').slice(-2)[0];

            $('body').addClass('modal-open');

            var firstPromise = getPromise('https://gateway.ecommerce-wh.com/shopify/orders/' + orderId + '/' + domain, function(data) {
                window.order.data = data;
                window.order.data.orderName = orderId;
            }, undefined, { internalDomain: window.liquidVars.adminDomain });

            var secondPromise = getPromise('https://gateway.ecommerce-wh.com/returnCustomer/findByCustomerEmailAndOrderId?orderId=' + orderId + '&email=' + email);

            Promise.all([firstPromise, secondPromise])
                .then(function(response) {
                    if (response[0] && response[0].line_items && response[0].email && response[0].email.toLowerCase().trim() === email) {
                        window.order.data = response[0];
                        window.order.data.email = email;
                        window.order.data.orderName = orderId;

                        setStep2Info(response);
                    } else {
                        if ($('#email').hasClass('has-success') && $('#orderId').hasClass('has-success')) {
                            $('#orderId-notFound').fadeIn();
                        }

                        $('body').removeClass('modal-open');
                    }
                })
                .catch(function(response) {
                    if ($('#email').hasClass('has-success') && $('#orderId').hasClass('has-success')) {
                        $('#orderId-notFound').fadeIn();
                    }

                    $('body').removeClass('modal-open');
                })
            ;
        }
    }

    function appendProduct(product, index, available) {
        var defaultImg = { src: 'https://cdn.shopify.com/s/files/1/0019/0477/1119/files/noimgavailable.png' };

        product.image = product.images && product.images.length ? (product.images.find(function(img) {
            return img.variant_ids.indexOf(product.variant_id) > -1;
        }) || defaultImg) : defaultImg;

        var productReturnOptions = (
            '<div class="radio">' +
                '<label>' +
                    '<input type="radio" name="radio_item_' + product.id + '_' + index + '" class="radio" value="None" checked> Nada' +
                '</label>' +
            '</div>' +
            '<div class="radio">' +
                '<label>' +
                    '<input type="radio" name="radio_item_' + product.id + '_' + index  + '" class="radio" value="Change"> Cambio' +
                '</label>' +
            '</div>' +
            '<div class="radio">' +
                '<label>' +
                    '<input type="radio" name="radio_item_' + product.id + '_' + index  + '" class="radio" value="Return"> Devolución' +
                '</label>' +
            '</div>'
        );

        $('#productContainer').append(
            '<li id="product_item_' + product.id + '_' + index  + '" class="list-group-item' + (available ? '' : ' disabled') + '">' +
                '<div class="row">' +
                    '<div class="col-xs-12 col-sm-6 item-preview">' +
                        '<img src="' + product.image.src + '" width="80px" alt="" />' +
                        '<span class="name">' + product.name + '</span>' +
                    '</div>' +
                    '<div class="col-xs-12 col-sm-6 text-center item-selectors">' +
                        (available ? productReturnOptions : '<p>Éste producto se encuentra bajo revisión por nuestro Servicio al Cliente</p><p>Si tiene cualquier duda, por favor no dude en <a href="/pages/contact-us#changes-return" target="_blank">contactar con nosotros</a></p>') +
                    '</div>' +
                '</div>' +
            '</li>'
        );
    }

    function setStep2Info(response) {
        var backofficeOrders = [];

        if (response[1]) {
            backofficeOrders = response[1];
        }

        var lineItemsVarName = 'line_items';
        var items = response[0][lineItemsVarName];

        var index;
        for (index in items) {
            items[index].availableQuantity =
                items[index].quantity - backofficeOrders.filter(function(returnItem) {
                    return parseInt(returnItem.shopifyLineItem) === parseInt(items[index].id);
                }).length
            ;
        }

        if (items.length) {
            $('#productContainer').html('');

            items.forEach(function(item) {
                for (counter = 0; counter < item.availableQuantity; counter++) {
                    appendProduct(item, counter, true);
                }

                for (counter = 0; counter < (item.quantity - item.availableQuantity); counter++) {
                    appendProduct(item, counter, false);
                }
            });

            $('input[type="radio"]').on('change', function() {
                window.stepController.disableNextSteps();
            });

            window.stepController.enableNextStep();
            window.stepController.goToStep(window.stepController.getActiveStep() + 1);
        }
    }

    function toogleFormClass(element, valid) {
        if (valid) {
            element.removeClass('has-error')
            element.addClass('has-success')
        } else {
            element.removeClass('has-success')
            element.addClass('has-error')
        }
    }

    function toogleError(errorElement, isValid) {
        if (isValid) {
            errorElement.hide();
        } else {
            if (errorElement.is(':hidden')) {
                errorElement.fadeIn();
            }
        }
    }

    var validationActive = false;

    function activateValidation() {
        if (!validationActive) {
            $('#email').on('keyup blur', function() {
                var isValid = isValidEmail($(this).val().toLowerCase().trim());

                toogleFormClass($(this), isValid);
                toogleError($('#email-notValid'), isValid);
            });

            $('#orderId').on('keyup blur', function() {
                var isValid = isValidOrderId($(this).val().toUpperCase().trim());

                toogleFormClass($(this), isValid);
                toogleError($('#orderId-notValid'), isValid);
            });

            validationActive = true;

            $('.formFields-1').keyup();
        }
    }

    function continueAction() {
        $('#orderId-notFound').hide();

        activateValidation();

        var emailVal = $('#email').val().toLowerCase().trim();
        var orderIdVal = $('#orderId').val().replace(/#/g, '').toUpperCase().trim();

        if (isValidEmail(emailVal) && isValidOrderId(orderIdVal)) {
            getOrder(emailVal, orderIdVal);
        } else {
            $('.formFields-1').keyup();
        }
    }

    $(document).ready(function() {
        $('.formFields-1').on('blur', function() {
            if (
                window.order.data &&
                (
                    window.order.data.id != $('#orderId').val().replace(/#/g, '').toUpperCase().trim() ||
                    window.order.data.email !== $('#email').val().toLowerCase().trim()
                )
            ) {
                window.stepController.disableNextSteps();
            }
        });

        $('#continue1').on('click', function(e) {
            continueAction();
        });

        $('.formFields-1').on('keyup', function(e) {
            if (e.which === 13 || e.keyCode === 13) {
                continueAction();
            }
        });
    });
})(jQuery, window);